/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getShipmentInvoices } from "api/services/invoice";
import { useCustomQuery } from "hooks/useCustomQuery";
import { invoiceQueryKeys } from "./invoiceQueryKeys";

type GetShipmentInvoicesOptions = {
  shipmentId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetShipmentInvoices = (data: GetShipmentInvoicesOptions) =>
  useCustomQuery({
    queryKey: invoiceQueryKeys.shipmentInvoicesListing(data.shipmentId),
    queryFn: data.queryFn ? data.queryFn : () => getShipmentInvoices(data.shipmentId).then((res) => res.data),
    ...data.options,
  });
